import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_5 = {
  key: 1,
  class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
  type: "button",
  disabled: ""
}
const _hoisted_6 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_7 = {
  key: 1,
  class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
  type: "button",
  disabled: ""
}
const _hoisted_8 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_9 = { class: "col-md-12" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md col-xm-12 col-sm-12" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = { class: "col-md" }
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_15 = { class: "col-md col-xm-12 col-sm-12" }
const _hoisted_16 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_17 = { class: "col-md" }
const _hoisted_18 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_19 = { class: "col-md col-xm-12 col-sm-12" }
const _hoisted_20 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_21 = { class: "col-md col-xm-12 col-sm-12" }
const _hoisted_22 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_23 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_24 = { class: "table-responsive" }
const _hoisted_25 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_26 = { class: "form-check" }
const _hoisted_27 = { class: "form-check" }
const _hoisted_28 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_29 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_30 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_31 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_32 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_33 = { class: "shadow-none lh-1 fw-medium text-black-emphasis text-center" }
const _hoisted_34 = {
  key: 0,
  class: "badge bg-danger text-white"
}
const _hoisted_35 = {
  key: 1,
  class: "badge bg-info text-white"
}
const _hoisted_36 = {
  key: 2,
  class: "badge bg-success text-white"
}
const _hoisted_37 = {
  key: 3,
  class: "badge bg-primary text-white"
}
const _hoisted_38 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_39 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_40 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_41 = { class: "shadow-none lh-1 fw-medium text-body-tertiary pe-0" }
const _hoisted_42 = { class: "dropdown" }
const _hoisted_43 = { class: "dropdown-menu" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { key: 0 }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { key: 1 }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = {
  class: "modal fade",
  id: "create-task",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_52 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_53 = { class: "modal-content" }
const _hoisted_54 = { class: "modal-body px-4" }
const _hoisted_55 = { class: "row gy-2" }
const _hoisted_56 = { class: "col-md-4-3" }
const _hoisted_57 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }
const _hoisted_58 = { class: "row" }
const _hoisted_59 = { class: "col-md-3" }
const _hoisted_60 = { class: "card" }
const _hoisted_61 = { class: "card-header" }
const _hoisted_62 = { class: "card-title" }
const _hoisted_63 = { class: "card-body d-flex justify-content-center" }
const _hoisted_64 = { class: "fs-4" }
const _hoisted_65 = { class: "col-md-3" }
const _hoisted_66 = { class: "card" }
const _hoisted_67 = { class: "card-header" }
const _hoisted_68 = { class: "card-title" }
const _hoisted_69 = { class: "card-body d-flex justify-content-center" }
const _hoisted_70 = { class: "fs-4" }
const _hoisted_71 = { class: "col-md-3" }
const _hoisted_72 = { class: "card" }
const _hoisted_73 = { class: "card-header" }
const _hoisted_74 = { class: "card-title" }
const _hoisted_75 = { class: "card-body d-flex justify-content-center" }
const _hoisted_76 = { class: "fs-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!
  const _component_PaginationComponent2 = _resolveComponent("PaginationComponent2")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "btn btn-primary",
          to: "/ajouter-facture"
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1),
            _createTextVNode(" Ajouter facture ")
          ])),
          _: 1
        })
      ]),
      ((_ctx.lesFactureAImprimer && _ctx.lesFactureAImprimer.length <= 0))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.valideEtape3)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getPoint())),
                  class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
                }, _cache[11] || (_cache[11] = [
                  _createElementVNode("i", { class: "flaticon-download position-relative ms-5 fs-12" }, null, -1),
                  _createTextVNode(" Exporter ")
                ])))
              : _createCommentVNode("", true),
            (!_ctx.valideEtape3)
              ? (_openBlock(), _createElementBlock("button", _hoisted_5, _cache[12] || (_cache[12] = [
                  _createElementVNode("span", {
                    class: "spinner-grow spinner-grow-sm",
                    role: "status",
                    "aria-hidden": "true"
                  }, null, -1),
                  _createElementVNode("span", { class: "visually-hidden" }, "Chargement...", -1)
                ])))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      ((_ctx.lesFactureAImprimer && _ctx.lesFactureAImprimer.length > 0))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_ctx.valideEtape3)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.imprimer())),
                  class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
                }, _cache[13] || (_cache[13] = [
                  _createElementVNode("i", { class: "flaticon-download position-relative ms-5 fs-12" }, null, -1),
                  _createTextVNode(" Télécharger ")
                ])))
              : _createCommentVNode("", true),
            (!_ctx.valideEtape3)
              ? (_openBlock(), _createElementBlock("button", _hoisted_7, _cache[14] || (_cache[14] = [
                  _createElementVNode("span", {
                    class: "spinner-grow spinner-grow-sm",
                    role: "status",
                    "aria-hidden": "true"
                  }, null, -1),
                  _createElementVNode("span", { class: "visually-hidden" }, "Chargement...", -1)
                ])))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Mot clé ", -1)),
              _createVNode(_component_Field, {
                modelValue: _ctx.motCle,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.motCle) = $event)),
                name: "mot",
                type: "text",
                "aria-disabled": "true",
                class: "form-control shadow-none fs-md-15 text-black",
                placeholder: "Recherche par mot clé"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "mot",
                class: "text-danger"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _cache[16] || (_cache[16] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Marché ", -1)),
              _createVNode(_component_Field, {
                modelValue: _ctx.marche,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.marche) = $event)),
                name: "marche"
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_Multiselect, _mergeProps({
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                  }, field, {
                    placeholder: "Sélectionner le contrat",
                    contratholder: "Rechercher une marché",
                    "filter-results": true,
                    searchable: true,
                    options: _ctx.marcheOptions,
                    noResultText: "Aucun enregistrement trouvé",
                    noOptionsText: "Tapez au moins trois caractères"
                  }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "marche",
                class: "text-danger"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _cache[17] || (_cache[17] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Statut ", -1)),
              _createVNode(_component_Field, {
                name: "statut",
                modelValue: _ctx._statut,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx._statut) = $event)),
                type: "text"
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_Multiselect, _mergeProps({
                    searchable: true,
                    options: [
                  { value: 0, label: 'Impayée' },
                  { value: 1, label: 'En attente ' },
                  { value: 2, label: 'Normalisée' },
                  { value: 3, label: 'Annulée' },
                  { value: 4, label: 'Normalisée & Payée' },
                  { value: 5, label: 'Avoir' }
                ],
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                  }, field, { placeholder: "Sélectionner le statut" }), null, 16, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _cache[18] || (_cache[18] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Type ", -1)),
              _createVNode(_component_Field, {
                modelValue: _ctx._type,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx._type) = $event)),
                name: "type"
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_Multiselect, _mergeProps({
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                  }, field, {
                    options: _ctx.typesOptions,
                    "preserve-search": true,
                    multiple: false,
                    searchable: true,
                    placeholder: "Sélectionner le type",
                    label: "label",
                    "track-by": "label"
                  }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "type",
                class: "text-danger"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _cache[19] || (_cache[19] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Mois ", -1)),
              _createVNode(_component_Field, {
                name: "mois",
                modelValue: _ctx._mois,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx._mois) = $event)),
                type: "text"
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_Multiselect, _mergeProps({
                    searchable: true,
                    options: [
                  { value: 0, label: 'Janvier' },
                  { value: 1, label: 'Février' },
                  { value: 2, label: 'Mars' },
                  { value: 3, label: 'Avril' },
                  { value: 4, label: 'Mai' },
                  { value: 5, label: 'Juin' },
                  { value: 6, label: 'Juillet' },
                  { value: 7, label: 'Août' },
                  { value: 8, label: 'Septembre' },
                  { value: 9, label: 'Octobre' },
                  { value: 10, label: 'Novembre' },
                  { value: 11, label: 'Décembre' },
                ],
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                  }, field, { placeholder: "Sélectionner le mois" }), null, 16, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _cache[20] || (_cache[20] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Année ", -1)),
              _createVNode(_component_Field, {
                name: "annee",
                modelValue: _ctx._annee,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx._annee) = $event)),
                type: "text"
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_Multiselect, _mergeProps({
                    options: _ctx._annees,
                    searchable: true,
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                  }, field, { placeholder: "Sélectionner une année" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "annee",
                class: "text-danger"
              })
            ])
          ])
        ])
      ])
    ]),
    _cache[41] || (_cache[41] = _createElementVNode("hr", null, null, -1)),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("table", _hoisted_25, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, [
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_Field, {
                    name: "checking",
                    type: "checkbox",
                    value: "Tout sélectionner",
                    id: "Tout sélectionner",
                    onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toggleAllCheckboxes($event))),
                    class: "form-check-input",
                    checked: _ctx.factures && _ctx.factures.length > 0 && _ctx.checkedFactures.length === _ctx.factures.length
                  }, null, 8, ["checked"])
                ])
              ]),
              _cache[21] || (_cache[21] = _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Reference ", -1)),
              _cache[22] || (_cache[22] = _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Nom du marchand ", -1)),
              _cache[23] || (_cache[23] = _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Code de la place ", -1)),
              _cache[24] || (_cache[24] = _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Date ", -1)),
              _cache[25] || (_cache[25] = _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Montant ", -1)),
              _cache[26] || (_cache[26] = _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Type ", -1)),
              _cache[27] || (_cache[27] = _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Mois ", -1)),
              _cache[28] || (_cache[28] = _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Contrat ", -1)),
              _cache[29] || (_cache[29] = _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Statut ", -1)),
              _cache[30] || (_cache[30] = _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 pe-0"
              }, "ACTIONS ", -1))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.factures, (facture, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_Field, {
                      name: "checking",
                      type: "checkbox",
                      onChange: ($event: any) => (_ctx.ajouterTableau($event, facture.id)),
                      value: facture.id,
                      id: facture.id,
                      class: "form-check-input",
                      modelValue: _ctx.checkedFactures,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.checkedFactures) = $event))
                    }, null, 8, ["onChange", "value", "id", "modelValue"])
                  ])
                ]),
                _createElementVNode("td", _hoisted_28, _toDisplayString(facture.reference), 1),
                _createElementVNode("td", _hoisted_29, _toDisplayString(facture?.nomMarchand), 1),
                _createElementVNode("td", _hoisted_30, _toDisplayString(facture?.codePlace), 1),
                _createElementVNode("td", _hoisted_31, _toDisplayString(facture.date_facture), 1),
                _createElementVNode("td", _hoisted_32, _toDisplayString(facture.montant_facture), 1),
                _createElementVNode("td", _hoisted_33, [
                  (facture?.natureFacture == 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_34, " Loyer "))
                    : _createCommentVNode("", true),
                  (facture?.natureFacture == 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_35, " Caution "))
                    : _createCommentVNode("", true),
                  (facture?.natureFacture == 2)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_36, " Electricité "))
                    : _createCommentVNode("", true),
                  (facture?.natureFacture == 3)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_37, " Loyer et Electricité "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_38, _toDisplayString(_ctx.moisNoms[parseInt(facture?.mois)]) + " " + _toDisplayString(facture?.annee), 1),
                _createElementVNode("td", _hoisted_39, _toDisplayString(typeof facture?.contrat === 'object' ? facture?.contrat?.reference : facture?.contrat), 1),
                _createElementVNode("td", _hoisted_40, [
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.getStatutBadge(Number(facture?.statut)).badgeClass)
                  }, _toDisplayString(_ctx.getStatutBadge(Number(facture.statut)).text), 3)
                ]),
                _createElementVNode("td", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _cache[36] || (_cache[36] = _createElementVNode("button", {
                      class: "btn btn-sm btn-primary",
                      type: "button",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, " Actions ", -1)),
                    _createElementVNode("ul", _hoisted_43, [
                      _createElementVNode("li", null, [
                        ((Number(facture.statut) === 0 || Number(facture.statut) === 1 || Number(facture.statut) === 3))
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              onClick: ($event: any) => (_ctx.openNewWindow(facture)),
                              type: "button",
                              class: "dropdown-item d-flex align-items-center"
                            }, _cache[31] || (_cache[31] = [
                              _createElementVNode("i", { class: "flaticon-send lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Aperçu facture ")
                            ]), 8, _hoisted_44))
                          : _createCommentVNode("", true),
                        ((Number(facture.statut) === 2 || Number(facture.statut) === 4 || Number(facture.statut) === 5))
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              onClick: ($event: any) => (_ctx.openNewWindow2(facture)),
                              type: "button",
                              class: "dropdown-item d-flex align-items-center"
                            }, _cache[32] || (_cache[32] = [
                              _createElementVNode("i", { class: "flaticon-send lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Aperçu facture ")
                            ]), 8, _hoisted_45))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          href: "javascript:void(0);",
                          onClick: ($event: any) => (_ctx.regenererEtImprimer(facture)),
                          type: "button",
                          class: "dropdown-item d-flex align-items-center"
                        }, _cache[33] || (_cache[33] = [
                          _createElementVNode("i", { class: "flaticon-printer lh-1 me-8 position-relative top-1" }, null, -1),
                          _createTextVNode(" Réimprimer (mis à jour) ")
                        ]), 8, _hoisted_46)
                      ]),
                      ((Number(facture.statut) === 0 || Number(facture.statut) === 1 || Number(facture.statut) === 3))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_47, [
                            _createElementVNode("a", {
                              onClick: ($event: any) => (_ctx.normaliser(facture)),
                              type: "button",
                              class: "dropdown-item d-flex align-items-center"
                            }, _cache[34] || (_cache[34] = [
                              _createElementVNode("i", { class: "flaticon-send lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Normalisée la facture ")
                            ]), 8, _hoisted_48)
                          ]))
                        : _createCommentVNode("", true),
                      ((Number(facture.statut) != 3 && Number(facture.statut) != 5 ))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_49, [
                            _createElementVNode("a", {
                              href: "javascript:void(0);",
                              "data-bs-target": "#create-task",
                              "data-bs-toggle": "modal",
                              onClick: ($event: any) => (_ctx.openModal(facture.id, facture.reference)),
                              class: "dropdown-item d-flex align-items-center"
                            }, _cache[35] || (_cache[35] = [
                              _createElementVNode("i", { class: "flaticon-close lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Annuler facture ")
                            ]), 8, _hoisted_50)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_51, [
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("div", _hoisted_53, [
            _cache[39] || (_cache[39] = _createElementVNode("div", { class: "modal-header" }, [
              _createElementVNode("h6", { class: "modal-title" }, "Voulez-vous annuler cette facture ?"),
              _createElementVNode("button", {
                type: "button",
                id: "close-modal",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              })
            ], -1)),
            _createElementVNode("div", _hoisted_54, [
              _createVNode(_component_Form, {
                ref: "depensesForm",
                onSubmit: _ctx.addFactures,
                "validation-schema": _ctx.facturesSchema
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _cache[37] || (_cache[37] = _createElementVNode("label", { class: "d-block fw-semibold mb-10" }, [
                        _createTextVNode(" Motif"),
                        _createElementVNode("span", { class: "text-danger" })
                      ], -1)),
                      _createVNode(_component_Field, {
                        name: "motifAnnuler",
                        as: "textarea",
                        placeholder: "Entrer le motif",
                        class: "form-control shadow-none rounded-0 text-black"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "motifAnnuler",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _cache[38] || (_cache[38] = _createElementVNode("div", { class: "modal-footer" }, [
                    _createElementVNode("button", {
                      type: "submit",
                      class: "btn btn-primary"
                    }, "Annuler"),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-danger",
                      "data-bs-dismiss": "modal",
                      "aria-label": "Close"
                    }, " Fermer ")
                  ], -1))
                ]),
                _: 1
              }, 8, ["onSubmit", "validation-schema"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_57, [
        _createVNode(_component_PaginationComponent2, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ]),
      _cache[40] || (_cache[40] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("div", _hoisted_58, [
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("h4", _hoisted_62, "Total factures " + _toDisplayString((_ctx._annee)? _ctx._annee : ''), 1)
            ]),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.separateur(_ctx.mt_total)), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_65, [
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("h4", _hoisted_68, "Total TVA " + _toDisplayString((_ctx._annee)? _ctx._annee : ''), 1)
            ]),
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.separateur(_ctx.mt_tva)), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_71, [
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("h4", _hoisted_74, "Total cautions " + _toDisplayString((_ctx._annee)? _ctx._annee : ''), 1)
            ]),
            _createElementVNode("div", _hoisted_75, [
              _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.separateur(_ctx.mt_caution)), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}